import { Breakpoints, styled } from '@vw-marketing/us-components';

export const AvatarContainer = styled.div<{
  size: number;
  backgroundColor: string;
  color: string;
}>`
  width: 60px;
  height: 60px;
  min-width: 60px;
  min-height: 60px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 28px;
  line-height: 32px;
  user-select: none;

  @media (min-width: ${Breakpoints.b560}px) {
    width: 72px;
    height: 72px;
    min-width: 72px;
    min-height: 72px;
    font-size: 32px;
    line-height: 36px;
  }
`;
